import React, { useState } from 'react';
import { CheckCircleIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
import { useForm } from '@formspree/react';
const TikTokIcon = ({
  className
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="currentColor" className={className} xmlns="http://www.w3.org/2000/svg" data-id="element-0">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-1" />
  </svg>;
export function App() {
  const [state, handleSubmit] = useForm('mldpynea');
  return <div className="min-h-screen flex flex-col items-center justify-center px-4 py-6 bg-gradient-to-br from-[#8554F6] to-[#C5ACFF]" data-id="element-2">
      <div className="w-full max-w-xl bg-white rounded-lg shadow-md overflow-hidden" data-id="element-3">
        <img src="https://cdn.magicpatterns.com/uploads/ahFSDbNb97c6PVoykd56PU/Banners_for_IA_CASSIE_CAREERACE.png" alt="Interview Ace Banner" className="w-full object-cover h-40 md:h-48" data-id="element-4" />
        <div className="p-5 md:p-6" data-id="element-5">
          <header className="text-center mb-3" data-id="element-6">
            <h1 className="text-2xl font-semibold text-gray-800 mb-1" data-id="element-7">
              Interview Ace
            </h1>
            <h2 className="text-base text-gray-600" data-id="element-8">
              Interview practice and career skills powered by Veer AI.
            </h2>
          </header>
          <div className="mb-5" data-id="element-9">
            <p className="text-gray-700 text-center text-sm px-2" data-id="element-10">
              Interview Ace is a career companion that helps jobseekers practice
              interviews, optimise their CVs, find jobs and career options and
              improve their chances in a rapidly changing world of work.
            </p>
          </div>
          {!state.succeeded ? <form onSubmit={handleSubmit} className="space-y-4 mb-4" data-id="element-11">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-12">
                <div data-id="element-13">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-14">
                    Name
                  </label>
                  <input type="text" id="name" name="name" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#8B5CF6] focus:border-[#8B5CF6]" data-id="element-15" />
                </div>
                <div data-id="element-16">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-17">
                    Work Email
                  </label>
                  <input type="email" id="email" name="email" required className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#8B5CF6] focus:border-[#8B5CF6]" data-id="element-18" />
                </div>
              </div>
              <button type="submit" disabled={state.submitting} className="w-full bg-[#8B5CF6] text-white text-lg py-2.5 px-4 rounded-md hover:bg-[#7c4fe3] transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-19">
                {state.submitting ? 'Sending...' : 'Request a demo'}
              </button>
            </form> : <div className="flex flex-col items-center justify-center space-y-2 mb-4 p-4 border border-green-100 rounded-md bg-green-50" data-id="element-20">
              <CheckCircleIcon className="h-10 w-10 text-green-500" data-id="element-21" />
              <p className="text-center text-green-800 text-sm font-medium" data-id="element-22">
                Thank you for your interest. We'll be in touch soon.
              </p>
            </div>}
          <footer className="text-center text-sm text-gray-500" data-id="element-23">
            <div className="flex justify-center gap-4 mb-3" data-id="element-24">
              <a href="https://www.instagram.com/veertechnologies" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#8B5CF6] transition-colors" aria-label="Instagram" data-id="element-25">
                <InstagramIcon className="h-5 w-5" data-id="element-26" />
              </a>
              <a href="https://www.tiktok.com/@veertechnologies" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#8B5CF6] transition-colors" aria-label="TikTok" data-id="element-27">
                <TikTokIcon className="h-5 w-5" data-id="element-28" />
              </a>
              <a href="https://www.linkedin.com/company/teamveer" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#8B5CF6] transition-colors" aria-label="LinkedIn" data-id="element-29">
                <LinkedinIcon className="h-5 w-5" data-id="element-30" />
              </a>
            </div>
            <p data-id="element-31">
              © 2026 Interview Ace — Powered by{' '}
              <img src="https://cdn.magicpatterns.com/uploads/86FWnk6M1177p932jBvCk9/veer.svg" alt="veer logo" className="inline-block h-3 w-auto align-text-bottom ml-1" data-id="element-32" />
            </p>
            <a href="/privacy" className="text-xs text-gray-400 hover:text-[#8B5CF6] transition-colors mt-2 inline-block" data-id="element-33">
              Privacy Policy
            </a>
          </footer>
        </div>
      </div>
    </div>;
}